/** Reserve Change report (legacy report ID 195). */
export const QUERY_RESERVE_CHANGE_REPORT_ID = 195;

export const QUERY_RESERVE_CHANGE_DEFAULT_CLAIM_ID = 'SEDGWICK';

/** Legacy Reserve Change report options default for RESERVE-AMT. */
export const QUERY_RESERVE_CHANGE_DEFAULT_MIN_CHANGE = '0';

export type ReserveChangeMinChangeUnit = 'Dollar' | 'Percent';

/** API returns Dollar/Percent; database stores legacy TRUE (Dollar) / FALSE (Percent). */
export function mapReserveChangeMinChangeUnitFromStorage(
  raw: string | null | undefined,
): ReserveChangeMinChangeUnit {
  const v = (raw ?? '').trim();
  if (!v) {
    return 'Dollar';
  }

  if (
    v.toUpperCase() === 'PERCENT' ||
    v.toUpperCase() === 'FALSE' ||
    v === '%' ||
    v.toUpperCase() === 'P' ||
    v.toUpperCase() === 'PCT'
  ) {
    return 'Percent';
  }

  return 'Dollar';
}

export function resolveReserveChangeDefaultClaimId(
  claimIdOptions: string[],
): string {
  const match = claimIdOptions.find(
    (x) => x.toUpperCase() === QUERY_RESERVE_CHANGE_DEFAULT_CLAIM_ID,
  );
  return match ?? claimIdOptions[0] ?? QUERY_RESERVE_CHANGE_DEFAULT_CLAIM_ID;
}

const RESCHED_WORK_STATUS_BEGIN_INDEX = 22;
const RESCHED_WORK_STATUS_END_INDEX = 23;

export function parseReschedWorkStatusIncrementFlags(reschedInfo: string | null | undefined): {
  beginSelected: boolean;
  endSelected: boolean;
} {
  if (!reschedInfo?.trim()) {
    return { beginSelected: true, endSelected: true };
  }

  const parts = reschedInfo.split(',');
  return {
    beginSelected: parseReschedYn(parts, RESCHED_WORK_STATUS_BEGIN_INDEX, true),
    endSelected: parseReschedYn(parts, RESCHED_WORK_STATUS_END_INDEX, true),
  };
}

function parseReschedYn(
  parts: string[],
  index: number,
  defaultValue: boolean,
): boolean {
  const token = parts[index]?.trim().toUpperCase();
  if (token === 'Y') {
    return true;
  }
  if (token === 'N') {
    return false;
  }
  return defaultValue;
}
